import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useState } from 'react';

function SidebarHelpProvider(props) {
	const [dataSidebar, setDataSidebar] = useState<ISidebarHelp>({
		title: '',
		firstParagraph: '',
		secondParagraph: '',
		urlVideo: '',
		firstLink: '',
		secondLink: '',
	});

	const states = { dataSidebar };
	const setters = { setDataSidebar };

	return (
		<SidebarHelpContext.Provider value={{ states, setters }}>
			{props.children}
		</SidebarHelpContext.Provider>
	);
}

export default SidebarHelpProvider;
